import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { allSharedComponents } from "../../../shared";
import AlreadyHaveAAccount from "./Components/AlreadyHaveAAccount";
import RegisterationDataForm from "./Components/RegisterationDataForm";
import { translationConstants, viewPathConstants } from "../../../constants";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import BaseChooseRegistrationView from "../../../shared/components/BaseChooseRegistrationType/BaseChooseRegistrationView";

const Registeration = () => {
  const { t } = useTranslation();
  const { GeneralLogo, BaseRegistrationForm, CustomModal, NavBar } =
    allSharedComponents;
  const [isShowRegistration, setShowRegistration] = useState(true);
  const [isShow, setShow] = useState(false);

  const toggleShowRegistration = () => {
    setShowRegistration((prev) => !prev);
  };

  const toggleShow = () => {
    setShow((prev) => !prev);
  };

  return (
    <>
      <div className="background-image">
        <div className="RegisterationContainer">
          <CustomModal
            scrollable={true}
            size="lg"
            show={isShowRegistration}
            isMoveToWP={true}
            setShow={toggleShowRegistration}
            closeBtnClasses={"login-modal-close-btn"}
          >
            <BaseRegistrationForm>
              <GeneralLogo />
              <BaseChooseRegistrationView
                setShow={toggleShow}
                toggleShowChoose={toggleShowRegistration}
              />
              <AlreadyHaveAAccount />
            </BaseRegistrationForm>
          </CustomModal>

          <CustomModal
            scrollable={true}
            size="lg"
            show={!isShowRegistration && isShow}
            setShow={toggleShow}
            closeBtnClasses={"login-modal-close-btn"}
            isMoveBack={true}
            onClose={()=>{
              setShowRegistration(true)
              toggleShow()
            }}
          >
            <BaseRegistrationForm>
              <GeneralLogo />
              <RegisterationDataForm />
              <AlreadyHaveAAccount />
            </BaseRegistrationForm>
          </CustomModal>
        </div>
      </div>
    </>
  );
};

export default Registeration;
